export const egypts = [
    {id:1,   name:"Slave Militia", wood:45, clay:60, iron:30, crop:15},
    {id:2,   name:"Ash Warden", wood:115, clay:100, iron:145, crop:60},
    {id:3,   name:"Khopesh Warrior", wood:170, clay:180, iron:220, crop:80},
    {id:4,   name:"Sopdu Explorer", wood:170, clay:150, iron:20, crop:40},
    {id:5,   name:"Anhur Guard", wood:360, clay:330, iron:280, crop:120},
    {id:6,   name:"Resheph Chariot", wood:450, clay:560, iron:610, crop:180},
    {id:7,   name:"Ram", wood:995, clay:575, iron:340, crop:80},
    {id:8,   name:"Stone Catapult", wood:980, clay:1510, iron:660, crop:100},
    {id:9,   name:"Nomarch", wood:34000, clay:50000, iron:34000, crop:42000},
    {id:10,  name:"Settler", wood:5040, clay:6510, iron:4830, crop:4620}
]

